/**
 * Fixed overlay z-index scale for portaled UI layers.
 *
 * Hierarchy (low → high):
 * - 102  popover, select, dropdown-menu, command combobox lists
 * - 105  dialog, alert-dialog
 * - 106  popover/select opened from inside a dialog (above dialog, below sheet)
 * - 110  sheet (slide-over panels)
 * - 115  walkthrough overlay (above sheet, below skip-link)
 * - 200  skip-link (a11y — see index.css)
 *
 * Do not use ad-hoc z-[9999] / z-[120]; extend this scale if a new layer is needed.
 */
export const Z_INDEX = {
  POPOVER: 102,
  /** Popover/select rendered from within a dialog */
  POPOVER_IN_DIALOG: 106,
  DIALOG: 105,
  SHEET: 110,
  WALKTHROUGH: 115,
  SKIP_LINK: 200,
};

/** Tailwind z-index utility classes for overlay primitives */
export const Z_CLASS = {
  POPOVER: 'z-[102]',
  POPOVER_IN_DIALOG: 'z-[106]',
  DIALOG: 'z-[105]',
  SHEET: 'z-[110]',
  WALKTHROUGH: 'z-[115]',
};
